import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import Tabs from "./Tabs";
import TabPane from "./TabPane";
import CouponItem from './CouponItem';

export class Coupon extends Component {
  state = {
    defaultActiveKey: 0,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillMount() {
    let { pathname } = this.props.history.location; 
    pathname = pathname.slice(pathname.lastIndexOf('/') + 1, pathname.length);
    this.setState({
      defaultActiveKey: parseInt(pathname, 10),
    })
  }
  updateRouter(activeKey) {
    this.props.history.replace(`/center/coupon/${activeKey}`);
  }
  render() {
    const { defaultActiveKey } = this.state;
    return (
      <div className="center-coupon">
        <div className="tabs">
          <Tabs
            {...this.props}
            defaultActiveKey={defaultActiveKey}
            isShowExplain={true}
            onTabsChange={(activeKey) => {
              this.setState({
                defaultActiveKey: activeKey
              });
              this.updateRouter(activeKey);
            }}
            tabs={[{ Name: "待使用" }, { Name: "已使用" }, { Name: "已失效" }]}
          />
        </div>
        <TabPane {...this.props} defaultActiveKey={defaultActiveKey}>
          <CouponItem {...this.props} type={1} active={true} />
          <CouponItem {...this.props} type={2} active={false} />
          <CouponItem {...this.props} type={3} active={false} />
        </TabPane>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Coupon);



// WEBPACK FOOTER //
// ./src/features/center/Coupon.js